import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { PinService } from '@services/pin.service';
import { Message } from '@models/message';
import { BackendValidationError } from '@models/backend-validation-error';
import { MessageBoxComponent } from '@modules/shell/components/message-box/message-box.component';

@Component({
    selector: 'auth-pwd-recovery',
    standalone: true,
    templateUrl: './pwd-recovery.component.html',
    styleUrl: './pwd-recovery.component.scss',
    imports: [
        CommonModule,
        RouterLink,
        ReactiveFormsModule,
        MatGridListModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule, 
        MatIconModule,
    ],
})
export class PwdRecoveryComponent {

    form : FormGroup;
    hide : boolean = true;
    message : Message | undefined = undefined;

    constructor(
        private dialog: MatDialog,
        private builder: FormBuilder,
        private pinService: PinService, 
        private router: Router) {

        this.form = this.builder.group({
            usr:    this.builder.nonNullable.control<string>('', [Validators.required, Validators.email,]),
            pwd:    this.builder.nonNullable.control<string>('', [Validators.required,]),
            pin:    this.builder.nonNullable.control<string>('', [Validators.required,]),
        });
        
    }

    pin() : void {

        this.message = undefined;

        if (this.form.get('usr')?.invalid) {
            this.dialog.open(MessageBoxComponent, {
                data: { 
                    text: "Enter your registered email.",
                    icon: 'error',                    }
                });
            return;
        }

        const usr: string= this.form.value.usr;

        this.pinService.post(usr).subscribe({
            next: (message) => {
                this.message = message;
            },
            error: (err) => {
                const error = new BackendValidationError(err);
                error?.setFormErrors(this.form);
            },
            complete: () => {
                const ref = this.dialog.open(MessageBoxComponent, {
                    data: { 
                        text: "PIN request accepted. Find it in your mailbox.",
                        icon: 'info',
                    }
                });
            }
        });
    }

    recover() : void {
        
        this.message = undefined;

    
        if (this.form.invalid) {
            //validation feedback directly in component template
            return
        }

        const usr: string= this.form.value.usr;
        const pwd: string= this.form.value.pwd;
        const pin: string= this.form.value.pin;

        this.pinService.patch(usr, pwd, pin).subscribe({
            next: (message) => {
                this.message = message;
            },
            error: (err) => {
                //console.log(err);
                const error = new BackendValidationError(err);
                error?.setFormErrors(this.form);
            },
            complete: () => {
                const ref = this.dialog.open(MessageBoxComponent, {
                    data: { 
                        text: "Password updated",
                        icon: 'info',
                    }
                });
                ref.afterClosed().subscribe(result => {
                    console.log('result');
                    console.log(result)
                    this.router.navigateByUrl('/login');
                });
            }
        });
    }

}
